const setItem = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export default setItem;
